import { toast } from "react-toastify";
import { translateMessage, translateMessages } from "./messageTranslator";

export const showError = (error) => {
  if (typeof error === "object") {
    for (let key in error) {
      if (Array.isArray(error[key])) {
        const translatedErrors = translateMessages(error[key]);
        for (const err of translatedErrors) {
          showErrorMsg(err);
        }
      } else if (typeof error[key] === "string") {
        showErrorMsg(translateMessage(error[key]));
      } else {
        showErrorMsg(translateMessage("An unknown error occurred."));
      }
    }
  } else if (typeof error === "string") {
    showErrorMsg(translateMessage(error));
  } else {
    showErrorMsg(translateMessage("An unknown error occurred."));
  }
};

export const getError = (error) => {
  let stringArray = [];
  for (let key in error) {
    for (const err of error[key]) {
      stringArray.push(translateMessage(err));
    }
  }
  return stringArray;
};

export const showErrors = (error) => {
  for (let key in error) {
    const val = error[key];
    if (Array.isArray(val)) {
      val.forEach((err) => toast.error(`${key}: ${err}`));
    } else if (typeof val === "string") {
      toast.error(`${key}: ${val}`);
    } else {
      toast.error(translateMessage(`${key}: ${String(val)}`));
    }
  }
};

export const showSuccess = (message) => {
  toast.success(translateMessage(message));
};

export const showInfo = (message, options = {}) => {
  return toast.info(message, options);
};

export const showErrorMsg = (
  error_msg,
  position = toast.POSITION.TOP_RIGHT
) => {
  toast.error(translateMessage(error_msg), { position: position });
};

export const showWarning = (warning) => {
  toast.warning(translateMessage(warning));
};
export const showEmptyError = (error1) => {
  toast.error(translateMessage(error1));
};
